<template>
    <div class="content">
        <header-top></header-top>
        <div class="form">
            <p v-if="!this.id">新增销售点</p>
            <p v-if="this.id">编辑销售点</p>
            <el-form :model="form" :rules="formRules" ref="ruleFormRef" :label-width="labelWidth">
                <!-- 企业分类 -->
                <el-form-item label="请选择类型：" prop="companyId" required>
                    <el-select v-model="form.companyId" placeholder="请选择" :disabled="!!id">
                        <el-option
                            v-for="item in companyList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <!-- 销售点名称 -->
                <el-form-item label="请输入销售点名称：" prop="title">
                    <el-input v-model="form.title" :disabled="!!id" class="titleInput"></el-input>
                </el-form-item>

                <!-- 选择地址 -->
                <el-form-item label="请输入地址：" prop="addr" required>
                    <city-picker
                        v-if="cityData.length"
                        ref="cityPicker"
                        :default-city="defaultCity"
                        :level="3"
                        @change="changeAddrSelece"
                        :cityData="cityData"
                        :disabledArr="[true, true, false]"
                    ></city-picker>
                    <el-input v-model="form.addr" placeholder="请输入详细地址" :disabled="!!id"></el-input>
                </el-form-item>

                <!-- 认证时间 -->
                <el-form-item label="认证时间：" prop="startTime">
                    <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>

                <!-- 联系人 -->
                <el-form-item label="联系人：">
                    <el-input v-model="form.contact" placeholder="请输入姓名"></el-input>
                </el-form-item>

                <!-- 联系方式 -->
                <el-form-item label="联系方式：">
                    <el-input v-model="form.mobile" placeholder="请输入联系方式"></el-input>
                </el-form-item>

                <!-- 有效期 -->
                <el-form-item label="有效期：" prop="endTime">
                    <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>

                <!-- 营业执照 -->
                <el-form-item label="营业执照：">
                    <div class="titleSize">请上传营业执照，图片格式为jpg或png，大小不能超过5M</div>
                    <el-upload
                        :action="domain"
                        :before-upload="beforUp"
                        :on-success="handleLicensedSuccess"
                        :data="formData"
                        :show-file-list="false"
                        accept="image/png, image/jpg, image/jpeg"
                        v-if="!form.licensed"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="licensedImg" v-if="form.licensed">
                        <img :src="form.licensed" />
                        <span class="iconfont icon-guanbi" @click.stop="deleteLicensedImg"></span>
                    </div>
                </el-form-item>

                <!-- 门头照片 -->
                <el-form-item label="门头照片：">
                    <div class="titleSize">请上传门头照片，图片格式为jpg或png，大小不能超过5M</div>
                    <div
                        v-for="(item,index) in form.storeImgs"
                        :key="'storeImgs'+ index"
                        class="images"
                    >
                        <img :src="item" />
                        <span class="iconfont icon-guanbi" @click.stop="deleteStoreImgs(index)"></span>
                    </div>
                    <el-upload
                        :action="domain"
                        :before-upload="beforUp"
                        :on-success="handleStoreImgsSuccess"
                        :data="formData"
                        :multiple="true"
                        :show-file-list="false"
                        accept="image/png, image/jpg, image/jpeg"
                        class="upload"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <!-- 店内照片 -->
                <el-form-item label="店内照片：">
                    <div class="titleSize">请上传店内照片，图片格式为jpg或png，大小不能超过5M</div>
                    <div
                        v-for="(item,index) in form.insideImgs"
                        :key="'insideImgs'+ index"
                        class="images"
                    >
                        <img :src="item" />
                        <span class="iconfont icon-guanbi" @click.stop="deleteInsideImgs(index)"></span>
                    </div>
                    <el-upload
                        :action="domain"
                        :before-upload="beforUp"
                        :on-success="handleInsideImgsSuccess"
                        :data="formData"
                        :multiple="true"
                        :show-file-list="false"
                        accept="image/png, image/jpg, image/jpeg"
                        class="upload"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <!-- 核查记录 -->
                <el-form-item label="核查记录：">
                    <div class="titleSize">若上传图片，只能上传jpg/png文件，且不超过5M</div>
                    <tinymce
                        menubar
                        :toolbar="['bold']"
                        :plugins="[]"
                        v-model="form.record"
                        :height="200"
                    ></tinymce>
                </el-form-item>

                <!-- 其他照片 -->
                <el-form-item label="其他：">
                    <div class="titleSize">请上传其他材料，如食品经营许可证，营业场所许可证，租赁合同，申报书等等，图片格式为jpg或png，大小不能超过5M</div>
                    <div v-for="(item,index) in form.others" :key="'others'+ index" class="images">
                        <img :src="item" />
                        <span class="iconfont icon-guanbi" @click.stop="deleteOthers(index)"></span>
                    </div>
                    <el-upload
                        :action="domain"
                        :before-upload="beforUp"
                        :on-success="handleOthersSuccess"
                        :data="formData"
                        :multiple="true"
                        :show-file-list="false"
                        accept="image/png, image/jpg, image/jpeg"
                        class="upload"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button class="saveBtn" type="primary" @click="save">确认</el-button>
                </el-form-item>
            </el-form>
        </div>
        <foot></foot>
    </div>
</template>

<script>
import headerTop from "@/components/header.vue";
import foot from "@/components/footer.vue";
import cityPicker from "@/components/CityPicker";
import datePickers from "@/components/data";
import tinymce from "@/components/Tinymce";
import { index, create, show, update, getCityData, uploadImg } from "@/api/common.js";
import store from "@/store";

export default {
    components: {
        headerTop,
        cityPicker,
        datePickers,
        foot,
        tinymce
    },
    mounted() {
        this.defaultCity.province = store.getters.userinfo.province;
        this.defaultCity.city = store.getters.userinfo.city;
        this.handleCityData();
        if (window.innerWidth <= 980) {
            this.labelWidth = "90px";
        } else {
            this.labelWidth = "190px";
        }
        this.id = this.$route.params.id || 0;
        this.getCompanyList();
    },
    data() {
        return {
            //   省市区初始值
            defaultCity: {
                province: "",
                city: "",
                area: ""
            },
            //表单
            form: {
                companyId: "",
                title: "",
                province: "",
                city: "",
                area: "",
                addr: "",
                startTime: "",
                contact: "",
                mobile: "",
                endTime: "",
                //营业执照图片
                licensed: "",
                //门头照片
                storeImgs: [],
                //店内照片
                insideImgs: [],
                record: "",
                //其他材料
                others: []
            },
            // 表单规则
            formRules: {
                title: [
                    {
                        required: true,
                        message: "请输入销售点名称",
                        trigger: "blur"
                    },
                    {
                        min: 2,
                        max: 30,
                        message: "长度在2到30个字符",
                        trigger: "blur"
                    }
                ],
                addr: [
                    {
                        required: true,
                        message: "请输入详细地址",
                        trigger: "blur"
                    }
                ]
            },
            companyList: [],
            domain: "",
            baseUrl: "",
            formData: {},
            // 每次查询一页，每页查询十项
            currentPage: 1,
            pageSize: 10,
            //点击编辑跳转过来的id
            id: 0,
            status: 0,
            type: 0,
            labelWidth: "",
            cityData: []
        };
    },
    methods: {
        // 获得企业分类
        getCompanyList() {
            index("urgentCompany").then(res => {
                this.companyList = res.data.rows;
            });
        },
        getEditList() {
            show("urgentreviewMaps", this.id).then(res => {
                this.status = res.data.status;
                if (res.data.status === 1) {
                    this.form = res.data.urgentlist;
                } else {
                    this.form = res.data.options;
                }
                this.$refs.cityPicker.changeCity({
                    province: this.form.province,
                    city: this.form.city,
                    area: this.form.area,
                    disabled: true
                });
            });
        },
        //选择地址
        changeAddrSelece(e) {
            this.form.province = e.data[0];
            this.form.city = e.data[1];
            this.form.area = e.data[2];
        },
        // 获得七牛路径及token
        beforUp() {
            return uploadImg().then(res => {
                this.domain = res.data.uploadUrl;
                this.formData = {
                    token: res.data.uploadToken
                };
                this.baseUrl = res.data.baseUrl;
            });
        },
        //营业执照上传成功
        handleLicensedSuccess(response, file) {
            if (file.size / 1024 > 5000) {
                return;
            }
            this.form.licensed = this.baseUrl + response.hash;
        },
        //删除营业执照图片
        deleteLicensedImg() {
            this.form.licensed = "";
        },
        //上传门头照片
        handleStoreImgsSuccess(response, file, fileList) {
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].size / 1024 > 5000) {
                    return;
                }
            }
            this.form.storeImgs.push(this.baseUrl + response.hash);
        },
        // 删除门头照片
        deleteStoreImgs(index) {
            this.form.storeImgs.splice(index, 1);
        },
        //上传店内照片
        handleInsideImgsSuccess(response, file, fileList) {
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].size / 1024 > 5000) {
                    return;
                }
            }
            this.form.insideImgs.push(this.baseUrl + response.hash);
        },
        // 删除店内照片
        deleteInsideImgs(index) {
            this.form.insideImgs.splice(index, 1);
        },
        //上传其他照片
        handleOthersSuccess(response, file, fileList) {
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].size / 1024 > 5000) {
                    return;
                }
            }
            this.form.others.push(this.baseUrl + response.hash);
        },
        // 删除其他照片
        deleteOthers(index) {
            this.form.others.splice(index, 1);
        },
        //提交
        save() {
            // console.log(1111, this.registerForm);
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    if (this.id) {
                        if (this.status === 1) {
                            update("urgentListMaps", this.form.id, {
                                ...this.form
                            }).then(res => {
                                this.$message.success("编辑成功");
                                this.$router.push({
                                    path: "/user/company"
                                });
                            });
                        } else {
                            update("urgentreviewMaps", this.id, {
                                options: this.form
                            }).then(res => {
                                this.$message.success("编辑成功");
                                this.$router.push({
                                    path: "/user/company"
                                });
                            });
                        }
                    } else {
                        create("urgentreview", {
                            options: this.form,
                            lid: 0,
                            type: 2
                        }).then(res => {
                            this.$message.success("添加成功");
                            this.$router.push({
                                path: "/user/company"
                            });
                        });
                    }
                } else {
                    if (!this.form.companyId) {
                        this.$message.error("请选择类型");
                    }
                }
            });
        },
        handleCityData() {
            getCityData({ notAll: true }).then(res => {
                this.cityData = res;
                if (this.id) {
                    this.getEditList();
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.form {
    width: 700px;
    margin: 20px auto 0;
}
p {
    text-align: center;
    font-size: 24px;
    margin-bottom: 30px;
}
/deep/.el-form {
    .el-form-item__label {
        font-size: 18px;
    }
}
.el-form-item__label,
div {
    font-size: 16px;
}
.el-input {
    width: 470px;
}
.el-icon-plus {
    width: 100px;
    height: 100px;
    border: 1px solid #ccc;
    line-height: 100px;
}
.licensedImg {
    position: relative;
    width: 100px;
    height: 100px;
    img {
        width: 100%;
        height: 100%;
    }
    span {
        position: absolute;
        top: -10px;
        right: 0;
        color: #ccc;
    }
}
.images {
    display: inline-block;
    margin: 0 2px 0 0;
    position: relative;
    width: 100px;
    height: 100px;
    img {
        width: 100%;
        height: 100%;
    }
    span {
        position: absolute;
        top: -10px;
        right: 0;
        color: #ccc;
    }
}
.upload {
    display: inline-block;
    vertical-align: top;
}
.saveBtn {
    width: 500px;
}
.titleSize {
    font-size: 12px;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
    .form {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 16px;
    }
    .titleInput {
        line-height: 40px;
    }
    .el-input {
        width: 100%;
    }
    .city-picker + .el-input {
        margin-top: 10px;
    }
    .saveBtn {
        width: 100%;
    }
}
</style>
<style>
.mce-btn button {
    padding: 0;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
    .el-form-item .el-button {
        width: 100%;
    }
    .form .el-form .el-form-item__label {
        font-size: 16px;
        float: none;
    }
    /* .el-form-item.btn .el-form-item__content {
    margin-left: 0 !important;
    display: flex;
  }
  .el-form-item.btn .el-form-item__content button {
    margin-right: 0;
    flex: 1;
  } */
    .el-form-item .el-select {
        line-height: 40px;
    }
    .form .el-form-item__content {
        margin-left: 0 !important;
    }
    .el-form-item__content {
        line-height: 20px;
    }
}
</style>



